import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-78e32abe")

import { withDefaults, computed } from 'vue';
import { RouteLocationNormalized } from 'vue-router';

interface Props {
  label?: string;
  variant?: 'primary' | 'secondary' | 'danger';
  type?: 'submit' | 'button';
  size?: 'md' | 'sm' | 'xs' | 'lg' | 'xl';
  disabled?: boolean;
  isText?: boolean;
  to?: RouteLocationNormalized;
  href?: string;
}


export default _defineComponent({
  props: {
    label: { type: String, required: false, default: '' },
    variant: { type: [String, String, String], required: false, default: 'primary' },
    type: { type: [String, String], required: false },
    size: { type: [String, String, String, String, String], required: false, default: 'md' },
    disabled: { type: Boolean, required: false, default: false },
    isText: { type: Boolean, required: false, default: false },
    to: { type: null, required: false },
    href: { type: String, required: false }
  } as unknown as undefined,
  emits: ['click'],
  setup(__props: {
  label?: string;
  variant?: 'primary' | 'secondary' | 'danger';
  type?: 'submit' | 'button';
  size?: 'md' | 'sm' | 'xs' | 'lg' | 'xl';
  disabled?: boolean;
  isText?: boolean;
  to?: RouteLocationNormalized;
  href?: string;
}, { emit }) {

const props = __props




const handleClick = (event: MouseEvent) => {
  if (!props.disabled) {
    emit('click', event);
  }
};

const renderTag = computed(() => {
  if (props.to) return 'router-link';
  if (props.href) return 'a';
  return 'button';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(renderTag)), {
    class: ["ui-button", [
    `ui-button--${__props.size}`,
    __props.isText ? 'ui-button-text' : 'ui-button-filled', // Base class for filled/text
    __props.isText ? `ui-button-text--${__props.variant}` : `ui-button-filled--${__props.variant}`, // Type variant for filled/text
    { 'ui-button--disabled': __props.disabled },
  ]],
    disabled: __props.disabled,
    onClick: handleClick,
    to: __props.to,
    href: __props.href,
    type: __props.type
  }, {
    default: _withId(() => [
      _renderSlot(_ctx.$slots, "left-icon"),
      _createVNode("span", null, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createTextVNode(_toDisplayString(__props.label), 1)
        ])
      ]),
      _renderSlot(_ctx.$slots, "right-icon")
    ]),
    _: 3
  }, 8, ["class", "disabled", "to", "href", "type"]))
}
}

})